<script lang="ts">
	import { translateDynKey } from '$lib';
	import Details from '$lib/components/product/Details.svelte';
	import { m } from '$lib/paraglide/messages.js';

	const { product, variant }: { product: Product; variant?: Variant } = $props();

	const excludedAdditionalAttributes: (
		| keyof typeof product.data
		| keyof NonNullable<typeof variant>['data']
	)[] = [
		'age_group',
		'attribute_set',
		'brand',
		'bundle',
		'color',
		'description',
		'ean_code',
		'family',
		'gender',
		'hilitr_rating',
		'images',
		'lang',
		'main_color_code',
		'manufacturer',
		'model_id',
		'mpn',
		'name',
		'news_from',
		'news_to',
		'quantity_sales_pack',
		'retrogaming',
		'season',
		'seller',
		'size',
		'short_description',
		'sku',
		'slug',
		'sport',
		'strung',
		'supplier',
	];
	let additionalAttributes = $derived(
		[...Object.entries(product.data), ...Object.entries(variant?.data ?? {})]
			.filter(
				([key, value]) =>
					value && !excludedAdditionalAttributes.includes(key as keyof typeof product.data),
			)
			.map(([key, value]) => ({ key, value }))
			.sort((a, b) => a.key.localeCompare(b.key)),
	);
</script>

{#snippet attributeLine(name: string, value: string | undefined)}
	{#if value}
		<tr class="size-6 border-b">
			<td class="w-1/2 font-semibold">{name}</td>
			<td class="w-1/2">{value}</td>
		</tr>
	{/if}
{/snippet}

<Details details={m.additional_information()} class="mt-5">
	<table class="w-full text-sm">
		<tbody>
			{@render attributeLine(m['attributes.brand'](), product.data.brand.name)}
			{#if variant}
				{@render attributeLine(m.supplier_reference(), variant.data.mpn)}
			{/if}
			{@render attributeLine(m['attributes.color'](), product.data.color)}
			{@render attributeLine(
				m['attributes.main_color'](),
				product.data.main_color_code &&
					translateDynKey(`main_colors.${product.data.main_color_code}`),
			)}
			{@render attributeLine(m['attributes.gender'](), product.data.gender)}
			{@render attributeLine(m['attributes.age_group'](), product.data.age_group)}
			{#each additionalAttributes as { key, value } (key)}
				{@render attributeLine(translateDynKey(`attributes.${key}`, key), value as string)}
			{/each}
		</tbody>
	</table>
</Details>
